import { createFileRoute } from '@tanstack/react-router';
import AccountingListViewContainer from '../accounting/AccountingListViewContainer';
export const Route = createFileRoute('/accounting/$type/')({
  component: AccountingListViewContainer,
});
